<div class="farm-activity-mobile-dialog">
  <kl-farmer-farm-activity
    [pageId]="dialogData?.data?.pageId"
    [selectedSeason]="dialogData?.data?.selectedSeason"
    (postCreated)="onPostCreated($event)">
  </kl-farmer-farm-activity>
</div>
